(function ($) {
    $(document).on('load', function () {
        $(".banner-second-level .content-outer").css("opacity","1");
        $(".banner-second-level .form button").css("display","inline-block");
        setTimeout(function () {
            $(".banner-second-level .form button").css({"visibility":"visible","opacity":"1"});
        },100);
    });
    $(document).ready(function () {
        $(".banner-second-level .content-outer").css("opacity","1");
        $(".banner-second-level .form button").css("display","inline-block");
        setTimeout(function () {
            $(".banner-second-level .form button").css({"visibility":"visible","opacity":"1"});
        },100);
    });
})(jQuery);